import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialLaboratoryFinanceState: Dtos.LaboratoryFinance & IRegistrationFormState = {
    id: null,
    laboratoryId: null,
    laboratory: null,
    bctInvoicingPrefix: null,
    taxInvoiceName: null,
    quickbooksTaxCodeId: null,
    quickbooksTaxCode: null,
    fundingEmailAddress: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ILaboratoryFinanceReduxFormState {
    id: IFieldState<number>,
    laboratoryId: IFieldState<number>,
    laboratory: IFieldState<Dtos.Laboratory>,
    bctInvoicingPrefix: IFieldState<string>,
    taxInvoiceName: IFieldState<string>,
    quickbooksTaxCodeId: IFieldState<number>,
    quickbooksTaxCode: IFieldState<Dtos.QuickbooksTaxCode>,
    fundingEmailAddress: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
